import React, { Component } from 'react';

class MixedAnswer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			label: '',
			value: '',
			config: {
				mostBeNum: false,
				numMin: '',
				numMax: '',
				replica: false,
				replicaLabel: ''
			}
		};
		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleOnCheck = this.handleOnCheck.bind(this);
	}
	static getDerivedStateFromProps(nextProps) {
		//Set state with the returned obj.
		if (nextProps.initialValues) {
			return nextProps.initialValues;
		}
		return null;
	}
	handleOnChange(e) {
		const { value, name } = e.target;
		const newState = { [name]: value };
		const { position } = this.props;
		if (name === 'numMin' || name === 'numMax' || name === 'replicaLabel') {
			const prevState = this.state.config;
			const newState = {
				config: {
					...prevState,
					[name]: value
				}
			};
			return this.props.parentStateCallback(newState, 'default', position);
		}
		this.props.parentStateCallback(newState, 'default', position);
	}
	handleOnCheck(e) {
		const { checked: value, name } = e.target;
		const prevState = this.state.config;
		const { position } = this.props;
		if (name === 'replica' && !value) {
			const newState = {
				config: {
					...prevState,
					[name]: value,
					mostBeNum: false,
					numMin: '',
					numMax: '',
					replicaLabel: ''
				}
			};
			return this.props.parentStateCallback(newState, 'default', position);
		}
		if (name === 'mostBeNum' && !value) {
			const newState = {
				config: {
					...prevState,
					[name]: value,
					numMin: '',
					numMax: ''
				}
			};
			return this.props.parentStateCallback(newState, 'default', position);
		}
		const newState = {
			config: {
				...prevState,
				[name]: value
			}
		};
		return this.props.parentStateCallback(newState, 'default', position);
	}
	renderReplicaLabel() {
		return (
			<div className="row">
				<div className="col-sm-1">
					<div className="form-check">
						<input
							type="checkbox"
							name="replica"
							checked={this.state.config.replica}
							onChange={this.handleOnCheck}
							className="form-check-input"
							id={`replica_${this.props.position}`}
						/>
						<label
							className="form-check-label"
							htmlFor={`replica_${this.props.position}`}
						>
							Réplica
						</label>
					</div>
				</div>
				<div className={this.state.config.replica ? 'col-sm-5' : 'd-none'}>
					<div className="form-group">
						<input
							type="text"
							name="replicaLabel"
							value={this.state.config.replicaLabel}
							onChange={this.handleOnChange}
							className="form-control"
						/>
					</div>
				</div>
			</div>
		);
	}
	renderReplicaNum() {
		return (
			<React.Fragment>
				<hr className={!this.state.config.replica ? 'd-none' : undefined} />
				<div className={this.state.config.replica ? 'row' : 'd-none'}>
					<div className="col-sm-6">
						<div className="form-group form-check">
							<input
								type="checkbox"
								name="mostBeNum"
								checked={this.state.config.mostBeNum}
								onChange={this.handleOnCheck}
								className="form-check-input"
								id={`mostBeNum_${this.props.position}`}
							/>
							<label
								className="form-check-label"
								htmlFor={`mostBeNum_${this.props.position}`}
							>
								La respuesta debe ser numeral.
							</label>
						</div>
					</div>
				</div>
				<div className={this.state.config.mostBeNum ? 'row' : 'd-none'}>
					<div className="form-check">
						<input
							type="number"
							name="numMin"
							id="numMin"
							placeholder="Mínimo numeral"
							value={this.state.config.numMin}
							onChange={this.handleOnChange}
							className="form-control"
						/>
					</div>
					<div className="form-check">
						<input
							type="number"
							name="numMax"
							id="numMax"
							placeholder="Máximo numeral"
							value={this.state.config.numMax}
							onChange={this.handleOnChange}
							className="form-control"
						/>
					</div>
				</div>
			</React.Fragment>
		);
	}
	render() {
		return (
			<React.Fragment>
				<div className="alert alert-dark">
					<div className="row">
						<div className="col-sm-6">
							<div className="form-group">
								<label>Respuesta</label>
								<input
									type="text"
									name="label"
									value={this.state.label}
									onChange={this.handleOnChange}
									className="form-control"
								/>
							</div>
						</div>
						<div className="col-sm-3">
							<div className="form-group">
								<label>Valor</label>
								<input
									type="text"
									name="value"
									value={this.state.value}
									onChange={this.handleOnChange}
									className="form-control"
								/>
							</div>
						</div>
					</div>
					{this.renderReplicaLabel()}
					{this.renderReplicaNum()}
				</div>
			</React.Fragment>
		);
	}
}

export default MixedAnswer;



// WEBPACK FOOTER //
// ./src/components/Survey/admin/EditFieldCollection/MixedAnswer.js